// @flow
import type {Node} from 'react'
import React, {useCallback, useRef} from 'react'
import {Modal as BootsrapModal} from 'reactstrap'

import Header from './Header'
import Body from './Body'
import Footer from './Footer'

type Props = $ReadOnly<{
  autofocus?: boolean,
  closeOnEscape?: boolean,
  close: () => void,
  children: Node,
  size?: string,
  'test-id'?: string | null,
  // deprecated
  onOpened?: () => void,
}>

function Modal({
  autofocus = true,
  closeOnEscape = true,
  close,
  children,
  size = '',
  onOpened,
  'test-id': testId = null,
}: Props): Node {
  const modalRef = useRef<?HTMLElement>(null)

  // reactstrap handles Esc on the .modal element, and without autoFocus focus
  // can stay outside it, so pull it in unless a field inside already took it.
  const handleOpened = useCallback(() => {
    const modal = modalRef.current
    if (modal && !modal.contains(document.activeElement))
      modal.focus()
    onOpened?.()
  }, [onOpened])

  return (
    <BootsrapModal
      autoFocus={autofocus}
      backdrop="static"
      backdropClassName="edit-dialog-modal__backdrop"
      className="edit-dialog-modal"
      fade={false}
      isOpen
      keyboard={closeOnEscape}
      labelledBy="modal-title"
      toggle={close}
      size={size}
      onOpened={handleOpened}
      innerRef={modalRef}
    >
      <div test-id={testId}>
        {children}
      </div>
    </BootsrapModal>
  )
}

Modal.Header = Header
Modal.Body = Body
Modal.Footer = Footer

export default Modal
